/**
 * A class to store a query parameter
 */
export class Parameter {
  /**
   * Constructor
   * @param name - The name of the parameter
   * @param value - THe paramter's value
   */
  constructor(public name: string, public value: string) {}
}
